/**
 * @module engine
 * @description Module and plugin registration system with dependency resolution
 *
 * @dependencies
 * - db/ (connection, schema-helpers, query-helpers, adapters)
 * - core/ (logger, events, utils, errors, middleware, crypto, socket, abilities, sse)
 * - runtime/ (entity-factory) - for createModuleContext()
 *
 * @exports registerModule - Register a module manifest
 * @exports registerPlugin - Register a plugin manifest
 * @exports shouldLoadPlugin - Check if plugin is enabled in nexus.plugins.json
 * @exports getModules - Get all registered modules
 * @exports getModule - Get module by name
 * @exports loadCoreModules - Load built-in core modules
 * @exports createModuleContext - Create context for module initialization
 */

// Escritura
export { registerModule, registerPlugin, shouldLoadPlugin } from './registry.js'

// Lectura
export {
  getModules,
  getOrderedModules,
  getOrderedModulesInternal,
  getModule,
  getPlugins,
  getPlugin,
  getRegisteredSubjects,
  isValidSubject,
  getSubjectForTable,
  getCoreModules,
  getUserModules,
  getCoreManifest,
  getUserManifest,
  hasUserApp,
  hasModule,
  hasPlugin,
  getPluginByCode,
  hasPluginByCode,
  getEntityDefinition
} from './module-queries.js'

export type { AppManifest } from './module-queries.js'

// Loader
export { loadCoreModules } from './loader.js'

// Store reset
export { resetStore } from './module-store.js'

// Internal types (for module-routes.ts and similar internal use)
export type { RegisteredModule } from './module-store.js'

// Extractors
export { getModuleSubjects } from './subject-extractor.js'
export { getTableAndSubject, topologicalSort, topologicalSortPlugins, validateModuleDependencies, validatePluginDependencies } from './definition-extractors.js'

// Context factory
export { createModuleContext, resetSharedAdapters, resetCacheManager, setLocales } from './context.js'

// Capabilities
export { CapabilitiesRegistry } from './capabilities-registry.js'

// Re-export types
export type { ModuleManifest, PluginManifest } from '@gzl10/nexus-sdk'
